import { useEffect, useState } from 'react';

/** True while a CSS media query matches (false where matchMedia is missing, e.g. tests) */
export function useMediaQuery(query: string): boolean {
  const read = () => typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(query).matches;
  const [matches, setMatches] = useState(read);
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;
    const mq = window.matchMedia(query);
    const onChange = () => setMatches(mq.matches);
    onChange();
    mq.addEventListener?.('change', onChange);
    return () => mq.removeEventListener?.('change', onChange);
  }, [query]);
  return matches;
}

/** Phase 18U U14: the desktop chart review uses two columns from 1024 px */
export const WIDE_REVIEW_QUERY = '(min-width: 1024px)';
